import React, {ReactNode} from "react";
import {ResponsivePie} from "@nivo/pie";
import FunctionHelper from "../helper/FunctionHelper";
import PortalPureComponent from "./PortalPureComponent";

interface ProgressCircleProperties {
	progress?: number;
	startAngle?: number;
	endAngle?: number;
	data?: any[];
	layers?: Array<any>;
	enableLabels?: boolean;
	arcLabel?: string;
	labelThreshold?: number;
}

export default class ProgressCircle extends PortalPureComponent<ProgressCircleProperties, any> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<div className="progress-circle">
				<ResponsivePie
					{...this.props}
					data={FunctionHelper.applyValue(this.props.data, [
						{id: "progress", value: this.props.progress, color: "#fbc200"},
						{
							id: "empty",
							value: 100 - FunctionHelper.applyValue(this.props.progress, 0),
							color: "#ffffff"
						}
					])}
					margin={{top: 2, right: 2, bottom: 2, left: 2}}
					layers={[
						'arcLinkLabels', 'arcs', 'arcLabels', 'legends',
						...FunctionHelper.applyValue(this.props.layers, [])
					]}
					arcLabel={this.props.arcLabel}
					enableArcLabels={FunctionHelper.applyValue(this.props.enableLabels, false)}
					enableArcLinkLabels={false}
					colors={(d: any) => {
						return d.data.color;
					}}
					isInteractive={false}
					innerRadius={0.5}
					borderWidth={2}
					borderColor={{
						from: "color",
						modifiers: [
							[
								"darker", 0.3
							]
						]
					}}
					animate={true}
					arcLabelsSkipAngle={3.6 * FunctionHelper.applyValue(
						this.props.labelThreshold, 0
					)}
				/>
			</div>
		);
	}
}